import { firestoreTimestampToDate, isDate } from "../utils/obejct-diff"

// export class ReportingContext {

//     // speciesToReport: string[]|undefined  
//     identifier: string
//     creationDate: Date|undefined
//     updateTimestamp: Date|undefined

//     constructor(
//         public reportingContextId: string,  // also identifier of doc
//         public huntingDistrictName: string, 
//     ) {
//         this.identifier = reportingContextId
//     }

//     setFromAny(element: any) {
//         // Object.assign(this, element)
//         const {
//             creationDate,
//             updateTimestamp
//         } = element
//         this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
//         this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
//     }

    
// }

export class DistrictReporting {

    identifier: string|undefined
    creationDate: Date|undefined
    updateTimestamp: Date|undefined

    constructor(
        public contextId: string,
        public reportingContextId: string,
        public reportingContextName: string,
        public huntingDistrictId: string, 
        public huntingDistrictName: string, 
        public reportingImages: boolean|undefined=false,
        public reportingPlaceOfKilling: boolean|undefined=false,
        public huntingDistrictAdministrativeName?: string, 
        public speciesToReport?: string[]|undefined,
        public reportingEmails?: string[]|undefined,
        public reportingEmailTemplate?:string | undefined
    ) {}

    setFromAny(element: any) {
        const {
            identifier,
            creationDate,
            updateTimestamp
        } = element
        this.identifier = identifier ? identifier : this.identifier
        this.creationDate = creationDate ? isDate(creationDate) ? creationDate : firestoreTimestampToDate(creationDate) : this.creationDate
        this.updateTimestamp = updateTimestamp ? isDate(updateTimestamp) ? updateTimestamp : firestoreTimestampToDate(updateTimestamp) : this.updateTimestamp
    }

    searchFilter(filter: string): boolean {
        const str = `${this.identifier}${this.huntingDistrictName}${this.reportingContextName}`.toLowerCase()
        return str.includes(filter)
    }
}

